const points = [
  "Four short steps",
  "No technical brief required",
  "Reviewed by the Utiva team",
];

const BuildFinalCtaSection = () => {
  return (
    <section className="apl-final">
      <div className="apl-shell apl-final-inner apl-reveal">
        <div className="apl-eyebrow">Bring it to the Lab</div>
        <h2>Tell us what is not working.</h2>
        <p>
          Complex problem. Manual process. Customer friction. New AI product
          idea. If a better product could change the outcome, we want to
          understand it.
        </p>
        <div className="apl-final-points">
          {points.map((point) => (
            <span key={point}>
              <i />
              {point}
            </span>
          ))}
        </div>
        <a className="apl-btn apl-btn-gold" href="#apply">
          Submit a Challenge
        </a>
      </div>
    </section>
  );
};

export default BuildFinalCtaSection;
